module.exports = __webpack_public_path__ + "static/AlpesControles-47fb8b09c4f26a504f4372ed833f8b4d.jpeg";